import { ModuleMap } from './module-map';
import Observer from '../common/Observer';
// import { searchBarModules } from '../common/utils/find-search-bar';

const moduleNameMap = new Map();

function generateModuleName(name, exact) {
    if (exact) {
        return name;
    }
    let count = moduleNameMap.get(name) || 0;
    count += 1;
    moduleNameMap.set(name, count);
    return `${name}-${count}`;
}

export function registerStoreModule(moduleItem, $store) {
    if (!$store) {
        throw new Error('vuex store is not installed when register module');
    }
    const { name } = moduleItem;
    let moduleConf = ModuleMap[name];
    moduleItem.blockOb = Object.freeze(new Observer());
    if (moduleConf) {
        if (!moduleItem.data) {
            moduleItem.data = {};
        }
        const storeName =
            moduleItem.data.$storeName || generateModuleName(name); // 复用服务端渲染的 $storeName
        typeof moduleConf === 'function' && (moduleConf = moduleConf($store));
        $store.registerModule(storeName, moduleConf, {
            preserveState: !!moduleItem.data.$storeName
        });
        moduleItem.data.$storeName = storeName;
        moduleItem.data.isBlockRoot = true;
        moduleItem.data.blockName = name;
    }
    return moduleItem;
}

function install(Vue) {
    Vue.mixin({
        beforeCreate() {
            const $options = this.$options;
            if ($options.parent && $options.parent.$storeName) {
                this.$storeName = $options.parent.$storeName;
                this.isBlockRoot = false;
                this.blockName = $options.parent.blockName;
            }
            const parent = $options.parent;
            if (parent && parent.$options.blockOb) {
                this.$options &&
                    (this.$options.blockOb = parent.$options.blockOb);
            }
        },
        beforeDestroy() {
            const $store = this.$store;
            if (!$store) {
                return;
            }
            if (this._isModuleRoot) {
                $store.unregisterModule(this.$storeName);
            }
        }
    });
}

export default install;
